import { gql } from 'react-apollo';

export const getMembersStatistics = gql`
  query getChurchGroupAllTimeMembersStatistics($churchId: Int!, $churchGroupId: Int!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          allTime: all_time {
            members {
              total
            }
          }
        }
      }
    }
  }
`;

export const getPointsEarnedStatistics = gql`
  query getChurchGroupAllTimePointsEarnedStatistics($churchId: Int!, $churchGroupId: Int!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          allTime: all_time {
            totalPointsEarned: total_points_earned {
              totalPointsEarned: total_points_earned
              delta
              distribution {
                intervalStart: interval_start
                totalPointsEarned: total_points_earned
              }
            }
          }
        }
      }
    }
  }
`;

export const getPrayingStatistics = gql`
  query getChurchGroypAllTimePrayingStatistics($churchId: Int!, $churchGroupId: Int!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          allTime: all_time {
            praying {
              timePrayed: time_prayed
              timePrayedForPastors: time_prayed_for_pastors
              timeDistribution: time_distribution {
                intervalStart: interval_start
                timePrayed: time_prayed
              }
            }
          }
        }
      }
    }
  }
`;

export const getFastingStatistics = gql`
  query getChurchGroupAllTimeFastingStatistics($churchId: Int!, $churchGroupId: Int!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          allTime: all_time {
            fasting {
              days
              full
              forMeal: for_meal
              membersCount: members_count
            }
          }
        }
      }
    }
  }
`;

export const getOvercomingStatistics = gql`
  query getChurchAllTimeOvercomingStatistics($churchId: Int!, $churchGroupId: Int!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          allTime: all_time {
            overcoming {
              days
              membersCount: members_count
            }
          }
        }
      }
    }
  }
`;

export const getGuestCardsActivitiesStatistics = gql`
  query getChurchGroupAllTimeGuestCardsActivitiesStatistics($churchId: Int!, $churchGroupId: Int!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          allTime: all_time {
            guestCardActivities: guest_card_activities {
              guestsTotal: guests_total,
              guestsApplicableForInvite: guests_applicable_for_invite,
              iaksSubmitted: iaks_submitted,
              iaksByTypeDistribution: iaks_by_type_distribution {
                iak {
                  name
                }
                count
              }
              iaksByDayDistribution: iaks_by_day_distribution {
                intervalStart: interval_start
                count
              }
            }
          }
        }
      }
    }
  }
`;

export const getGoalsAndAveragesStatistics = gql`
  query getChurchGroupAllTimeGoalsAndAveragesStatistics($churchId: Int!, $churchGroupId: Int!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          allTime: all_time {
            goalsAndAverages: goals_and_averages {
              pointsAverage: points_average
              timePrayedAverage: time_prayed_average
              iaksAverage: iaks_average
              pointsGoalPercentage: points_goal_percentage
              timePrayedGoalPercentage: time_prayed_goal_percentage
              iaksGoalPercentage: iaks_goal_percentage
            }
          }
        }
      }
    }
  }
`;

export const getGroupPerformanceStatistics = gql`
  query getChurchGroupAllTimeGroupPerformanceStatistics($churchId: Int!, $churchGroupId: Int!) {
    statistics {
      churchManager: church_manager {
        group(church_id: $churchId, church_group_id: $churchGroupId) {
          allTime: all_time {
            groupPerformance: group_performance {
              position
              topPerformers: top_performers {
                position
                members {
                  id
                  name
                  photo {
                    small
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/allTime/queries/queries.js